import { useEffect } from 'react';
import { websocketClient } from '../services/websocket-client';

const BASE_TITLE = 'Holds Request Application';

/**
 * Updates the browser tab title with the unread notification count.
 * Shows "(3) Holds Request Application" when there are unread notifications.
 * Clears when the user marks notifications as read (count goes to 0).
 */
export function useTabBadge() {
  useEffect(() => {
    const updateTitle = (count: number) => {
      document.title = count > 0 ? `(${count}) ${BASE_TITLE}` : BASE_TITLE;
    };

    const unsubscribe = websocketClient.onUnreadCount(updateTitle);

    // Reset title on unmount
    return () => {
      unsubscribe();
      document.title = BASE_TITLE;
    };
  }, []);
}
